import React, { useState, useEffect } from "react";
import { Box, Typography, Paper, Button, CircularProgress } from "@mui/material";
import { toast } from 'react-toastify';
import PageHeader from "../../components/PageHeader";
import CrudManager from "../../utils/Crud-Manager/CrudManager";
import useApi from "../../utils/useApi";
import settlement from "../support/Data/transactionSettlement.json";
const Settlement = () => {
  const [showMigrateButton, setShowMigrateButton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { Get, Post } = useApi();


  const checkAutoProcess = async () => {
    try {
      const response = await Get("appEnv");
      if (response?.results) {
        const autoProcessItem = response.results.find(item => item.key === "AUTO_PROCESS");
        setShowMigrateButton(autoProcessItem?.value === "False");
      }
    } catch (error) {
      console.error('Error checking auto process:', error);
      setShowMigrateButton(false);
    }
  };

  const handleMigrateTransaction = async () => {
    setIsLoading(true);
    try {
      const response = await Post("migrateTransactionComparison", {});
      if (response.data.success) {
        const message = response.data.message.replace(/errors/g, 'skipped records');
        toast.success(message);
      } else {
        toast.error(response.message || 'Migration failed');
      }
    } catch (error) {
      console.error('Error migrating transaction:', error);
      toast.error('Migration failed');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    checkAutoProcess();
  }, []);

  return (
    <Box sx={{ display: "flex" }}>
      <Box
        sx={{
          flexGrow: 1,
          marginTop: 0,
          marginLeft: 15,
          marginRight: 15,
          marginBottom: 15,
        }}
      >
        <PageHeader pageTitle="Transaction Settlement" />

        <Paper elevation={3} sx={{ padding: 3, marginTop: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6">
              Transaction Settlement To Customer Account
            </Typography>
            {showMigrateButton && (
              <Button
                variant="contained"
                color="primary"
                onClick={handleMigrateTransaction}
                disabled={isLoading}
                startIcon={isLoading ? <CircularProgress size={20} /> : null}
              >
                {isLoading ? 'Migrating...' : 'Migrate Transaction'}
              </Button>
            )}
          </Box>
          <CrudManager
            hideDelete={true}
            data={settlement}
            createRequired={false}
            editRequired={false}
            searchRequired={true}
            actionBtnName={false}
            createFormTitle=""
            updateFormTitle=""
          />
        </Paper>
      </Box>
    </Box>
  );
};

export default Settlement;